/* eslint-disable global-require */

export default {
  homescapes: [
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/ko/preview-01.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/ko/preview-02.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/ko/preview-03.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/ko/preview-04.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/ko/preview-05.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/ko/preview-06.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/ko/preview-07.webp'),
    },
  ],
  township: [
    {
      type: 'image',
      link: require('@/assets/images/township/preview/ko/preview-01.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/township/preview/ko/preview-02.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/township/preview/ko/preview-03.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/township/preview/ko/preview-04.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/township/preview/ko/preview-05.webp'),
    },
  ],
};
